import { render, staticRenderFns } from "./Denuncia.vue?vue&type=template&id=6454b790&scoped=true&"
import script from "./Denuncia.vue?vue&type=script&lang=js&"
export * from "./Denuncia.vue?vue&type=script&lang=js&"
import style0 from "./Denuncia.vue?vue&type=style&index=0&id=6454b790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6454b790",
  null
  
)

export default component.exports